module.exports = __webpack_public_path__ + "img/Menu-10.52f6da0b.png";